import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseService } from 'src/app/system-common/services/base.service';
import { Observable } from 'rxjs';

@Injectable()
export class PolicyDetailsServiceHandler extends BaseService {
  public policyFacets: any;
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, 'POLICY');
  }

  public init(modelNameList: string[]) {
    return this.getPolicy(0, modelNameList);
  }

  public load(id: any, modelNameList: string[]) {
    return this.getPolicy(id, modelNameList);
  }

  public process(id: any, modelNameList: string[]) {
    return this.savePolicy(id, modelNameList);
  }

  public find(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getPolicySearchList(executeSearch, searchCriteriaData);
  }

  public findForLanding(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getSearchList('TrackLeadAtEAppStage', executeSearch, searchCriteriaData);
  }

  public clear() {
    super.clear();
  }

  private getPolicySearchList(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getSearchList('SearchPolicy', executeSearch, searchCriteriaData);
  }

  private getPolicy(id: number, modelNameList: any) {
    let body = this.getFetchBody(modelNameList, true);
    let path = this.getURLValue('POLICY');
    if (id != 0) {
      return this.httpPost(`${path}/${id}`, body, undefined, true);
    } else if (id == 0) {
      return this.httpPost(`${path}`, body);
    }
  }

  private savePolicy(id, modelNameList) {
    let body = this.getPostBody(modelNameList, true);
    let path = id == 0 ? `${this.getURLValue('POLICY')}` : `${this.getURLValue('POLICY')}/${id}`;
    console.log(body);
    return this.httpPut(path, body);
  }

  getUIFacets(): Observable<Object> {
    let body = {};
    let path = this.getURLValue('FACET');
    return this.httpPost(`${path}/getUIFacet`, body);
  }

  findByPolicyId(policyId: string): Observable<Object> {
    return this.httpGet(`${this.getURLValue('POLICY')}/${policyId}`);
  }

  getMyPolicies(fieldName?): Observable<any> {
    let body = {
      fieldName: fieldName ? [fieldName] : [],
    };

    let path = this.getURLValue('POLICY');
    return this.httpPost(`${path}/getMyPolicies`, body);
  }

  getMyCustomer(): Observable<Object> {
    let body = {};
    let path = this.getURLValue('POLICY');
    return this.httpGet(`${path}/getMyCustomer`);
  }
}
